import { createWithEqualityFn } from 'zustand/traditional';

import { postSaveFilter, deleteSaveFilter } from '@api/schoolSaveFilter';

import { SchoolSearchState } from '@store/SchoolSearchFiltersStore';
import useNotificationStore from '@store/NotificationStore';
import useUserPreferencesStore from '@store/UserPreferencesStore';

export interface SaveSchoolFilterStore {
  isLoading: boolean;
  saveNewFilter: (filters: Partial<SchoolSearchState>) => Promise<void>;
  deleteSavedFilter: (filterId: string) => void;
}

const initialState = {
  isLoading: false,
};

export const useSaveSchoolFilterStore = createWithEqualityFn<SaveSchoolFilterStore>()(
  () => ({
    ...initialState,

    saveNewFilter: async (filters: Partial<SchoolSearchState>) => {
      const userPreferences = await postSaveFilter(filters);

      useNotificationStore.getState().notify({
        message: `Added Saved Filter`,
        severity: 'info',
      });

      useUserPreferencesStore.getState().setUserPreferences(userPreferences);
    },

    deleteSavedFilter: async (filterId: string) => {
      const userPreferences = await deleteSaveFilter(filterId);

      useNotificationStore.getState().notify({
        message: `Removed Saved Filter`,
        severity: 'info',
      });

      useUserPreferencesStore.getState().setUserPreferences(userPreferences);
    },
  }),
  Object.is,
);
